import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class FormControlUtilityService {

    clearControl(control: AbstractControl | null | undefined): void {
        if (!control) {
            return;
        }

        control.setValue('');
        control.markAsDirty();
        control.markAsTouched();
    }
}
